export default __webpack_public_path__ + "static/media/website-19.178fd077.jpg";